<template>
  <section>
    <el-card>
      <h2>Page Not Found</h2>
    </el-card>
  </section>
</template>
